import { appApi, useDeleteSessionMutation } from 'src/app/appApiQueries'
import { setType } from 'src/app/modal'
import { useAppDispatch, useAppSelector } from 'src/hooks'
import ModalTitle from '../ModalTitle'
import ModalButtons from '../ModalButtons'
import useModalLoading from 'src/hooks/useModalLoading'
import { FC, useCallback } from 'react'
import { setCurrentPage } from 'src/app/page'
import { selectSessionId } from 'src/app/session'

type SessionDeleteModalProps = { groupId: string; id: string }

export const SessionDeleteModal: FC<SessionDeleteModalProps> = ({
  groupId,
  id,
}) => {
  const activeSessionId = useAppSelector(selectSessionId)
  const [deleteSession, { isLoading, isSuccess, isError }] =
    useDeleteSessionMutation()
  const dispatch = useAppDispatch()
  useModalLoading({ isLoading, isSuccess, isError })
  const isActiveSession = activeSessionId === id

  const onDeleteSession = useCallback(() => {
    deleteSession({ groupId, id })
      .unwrap()
      .then(() => {
        if (!isActiveSession) {
          dispatch(appApi.util.invalidateTags(['AllSessions']))
        }
        dispatch(setCurrentPage({ page: 'Home' }))
      })
  }, [deleteSession, dispatch, groupId, id, isActiveSession])

  const onCancel = () => {
    dispatch(setType({ type: null }))
  }

  return (
    <div>
      <ModalTitle styles="font-bold" text="Delete Session" />

      <p className="text-base">
        Once deleted, this session cannot be recovered
      </p>

      <ModalButtons
        firstButton={{
          name: 'Cancel',
          type: 'secondary',
          onClick: onCancel,
          htmlButtonType: 'button',
        }}
        secondButton={{
          name: 'Delete',
          type: 'warning',
          onClick: onDeleteSession,
          htmlButtonType: 'button',
        }}
      />
    </div>
  )
}
